import UpdateNepalCases from './UpdateNepalCases';

export default UpdateNepalCases;
